import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useBondsBondApi } from '../../../../../../../../../../../../../../../../../../../../actor/api/Services/bonds/bond/hooks/api';
import { SideBarActions } from '../actions';
import { LinkedBondsElementContainer } from '../container';
import { LinkedBondsElementDetails } from '../details';
import { LinkedBondsElementTitle } from '../title';
import { LinkedBondsElementWrapper } from '../wrapper';
import { useAddBondInvalidSAccIds } from '../../../../../../../../../../../../../../../../../../../../sanity/queries/news/byId/hooks/bonds/context/hooks';
import { useBondSAccId } from '../../../../../../../../../../../../../../../../../../../../actor/api/Services/bonds';

export const NewsBondElementContent = (props: {
  position?: ouiStyle.InStyleWithMediaQueries['position'],
  top?: ouiStyle.InStyleWithMediaQueries['top'],
  bottom?: ouiStyle.InStyleWithMediaQueries['bottom'],
  left?: ouiStyle.InStyleWithMediaQueries['left'],
  right?: ouiStyle.InStyleWithMediaQueries['right'],
  transform?: ouiStyle.InStyleWithMediaQueries['transform'],
}) => {
  const {
    position,
    top,
    bottom,
    left,
    right,
    transform,
  } = props;
  const {
    data,
    isLoading,
  } = useBondsBondApi();
  const bondSAccId = useBondSAccId();
  const addInvalidBondId = useAddBondInvalidSAccIds();
  React.useEffect(() => {
    if (data == null && isLoading === false) {
      addInvalidBondId(bondSAccId);
    }
  }, [data, isLoading, bondSAccId, addInvalidBondId]);
  if (data == null && isLoading === false) {
    return null;
  }
  return (
    <LinkedBondsElementWrapper
      transform={transform}
      position={position}
      top={top}
      bottom={bottom}
      left={left}
      right={right}
    >
      <LinkedBondsElementContainer>
        <LinkedBondsElementTitle />
        <LinkedBondsElementDetails />
        <SideBarActions />
      </LinkedBondsElementContainer>
    </LinkedBondsElementWrapper>
  );
};
